/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_GInputs */

const en_tut_rapat_g = /** @type {(inputs: Tut_Rapat_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meetings here are not links from another app. Invitations follow workspace membership, and the results — transcript, notes, decisions — stay where the work is.`)
};

const id_tut_rapat_g = /** @type {(inputs: Tut_Rapat_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapat di sini bukan tautan dari aplikasi lain. Undangannya mengikuti keanggotaan workspace, dan hasilnya — transkrip, catatan, keputusan — tinggal di tempat pekerjaannya.`)
};

/**
* | output |
* | --- |
* | "Meetings here are not links from another app. Invitations follow workspace membership, and the results — transcript, notes, decisions — stay where the work is." |
*
* @param {Tut_Rapat_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_g = /** @type {((inputs?: Tut_Rapat_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_g(inputs)
	return en_tut_rapat_g(inputs)
});